import { useParams } from 'react-router-dom';
import { ROUTES } from '../../../common/constants/routes';
import IParams from '../../model/IParams';

interface IUseStockUrlReturn {
  listUrl: string;
  detailsUrl: string;
}

const useStockUrl: (externalId?: string) => IUseStockUrlReturn = externalId => {
  const { trimCode } = useParams<IParams>();

  const listUrl = `${ROUTES.CONFIGURE_BASE}${trimCode}/stock/list`;
  const detailsUrl = `${ROUTES.CONFIGURE_BASE}${trimCode}/stock/details/${externalId ?? ''}`;

  return { listUrl, detailsUrl };
};

export default useStockUrl;
